import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Loading from "../Components/global/Loading";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsersList } from "../redux/actions/contents";
import PageName from "../Components/global/PageName";
import { FaUserShield, FaUserCheck, FaPhoneAlt, FaEnvelope, FaUsers } from "react-icons/fa";

export default function UsersManagement() {
  const dispatch = useDispatch();
  const { usersList, loading: usersLoading } = useSelector(
    (state) => state.content
  );
  const [pageNo] = useState(1);
  const [pageSize] = useState(20);

  useEffect(() => {
    dispatch(getAllUsersList(pageNo, pageSize));
  }, [dispatch, pageNo, pageSize]);

  return (
    <div className="min-h-screen pb-16 bg-[#0A0A0C] text-[#F8F5F2]">
      <PageName
        title="Users Management"
        subTitle="Manage administrative users, telecallers, and system accounts in dark mode."
      />

      <div className="max-w-7xl mx-auto px-4 mt-4">
        <div className="overflow-x-auto rounded-3xl shadow-[0_15px_40px_rgba(0,0,0,0.7)] border border-[#C8A165]/25 bg-[#121215]/90 backdrop-blur-2xl text-left">
          <table className="min-w-full divide-y divide-[#C8A165]/15 text-xs">
            <thead className="bg-[#18181D] text-[#C8A165] uppercase tracking-widest font-bold">
              <tr>
                <th className="px-6 py-4 text-left">#</th>
                <th className="px-6 py-4 text-left">User Name</th>
                <th className="px-6 py-4 text-left">Email Address</th>
                <th className="px-6 py-4 text-left">Mobile Contact</th>
                <th className="px-6 py-4 text-center">User Access Role</th>
                <th className="px-6 py-4 text-center">Registered Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#C8A165]/10">
              {usersList?.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center py-16 text-[#F8F5F2]/40">
                    <FaUsers size={32} className="mx-auto mb-2 text-[#C8A165]" />
                    No users registered in database.
                  </td>
                </tr>
              ) : (
                usersList?.map((item, index) => (
                  <motion.tr
                    key={item?.id || index}
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.04 }}
                    className="hover:bg-white/[0.03] transition-colors"
                  >
                    <td className="px-6 py-4 font-bold text-[#F8F5F2]/40">
                      {(pageNo - 1) * pageSize + (index + 1)}.
                    </td>
                    <td className="px-6 py-4 font-bold text-[#F8F5F2] flex items-center gap-2.5">
                      <div className="w-9 h-9 rounded-xl bg-gradient-to-tr from-[#C8A165] to-[#F5E5C9] text-[#0A0A0C] font-bold flex items-center justify-center text-xs shadow-md">
                        {item.fullName?.[0]?.toUpperCase() || "U"}
                      </div>
                      <span className="capitalize">{item.fullName}</span>
                    </td>
                    <td className="px-6 py-4 text-[#F8F5F2]/70">
                      <div className="flex items-center gap-1.5">
                        <FaEnvelope size={11} className="text-[#C8A165]/70" />
                        <span>{item.email}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-[#F8F5F2]/80">
                      <div className="flex items-center gap-1.5">
                        <FaPhoneAlt size={10} className="text-[#C8A165]" />
                        <span>{item.mobileNo || "N/A"}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span className="inline-flex items-center gap-1.5 bg-[#C8A165]/15 text-[#C8A165] border border-[#C8A165]/30 text-[0.68rem] font-extrabold uppercase px-3.5 py-1 rounded-full">
                        {item?.userType === "admin" ? (
                          <FaUserShield size={11} className="text-[#C8A165]" />
                        ) : (
                          <FaUserCheck size={11} className="text-[#C8A165]" />
                        )}
                        {item?.userType}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center text-[#F8F5F2]/50 font-medium">
                      {item?.createdAt ? new Date(item.createdAt).toLocaleDateString() : "N/A"}
                    </td>
                  </motion.tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {usersLoading && <Loading />}
    </div>
  );
}
